import { useState, useEffect } from 'react';
import { geocodeByAddress } from 'react-google-places-autocomplete';
import { normaliseGeocodedState } from '../utils';

export const useLocationGeocoding = (address) => {
  const [addressDetails, setAddressDetails] = useState({
    city: '',
    street: '',
    state: '',
    zip: '',
  });

  useEffect(() => {
    const fetchAddressDetails = async () => {
      try {
        const result = await geocodeByAddress(address.label);
        if (!result) return;

        const {
          value: {
            structured_formatting: { main_text, secondary_text },
          },
        } = address;

        const parsedSecondaryAddress = secondary_text.split(',');
        const addressComponents = result[0].address_components;

        const adminArea =
          addressComponents.find((component) =>
            component.types.includes('administrative_area_level_1')
          )?.long_name || '';

        const postalCode =
          addressComponents.find((component) =>
            component.types.includes('postal_code')
          )?.long_name || '';

        setAddressDetails({
          street: main_text,
          city: parsedSecondaryAddress[0] || '',
          state: normaliseGeocodedState(adminArea),
          zip: postalCode,
        });
      } catch (err) {
        console.error('error geocoding address');
      }
    };

    if (address) fetchAddressDetails();
  }, [address]);

  return addressDetails;
};
